import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IParentEventResponse, IParentEventState } from '../../interface/parentEvent.interface';
import { fetchParentEvents } from '../action/parentEvent.action';

const initialState: IParentEventState = {
  events: [],
  total: 0,
  loading: false,
  error: null,
};

const parentEventSlice = createSlice({
  name: 'parentEvent',
  initialState,
  reducers: {
    // The page dispatches this on mount and whenever the guardian switches
    // child, so one child's events never flash on another child's page.
    resetParentEventState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParentEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchParentEvents.fulfilled,
        (state, action: PayloadAction<IParentEventResponse>) => {
          state.loading = false;
          state.events = action.payload.data?.events || [];
          state.total = action.payload.data?.total || 0;
          state.error = null;
        },
      )
      .addCase(fetchParentEvents.rejected, (state, action) => {
        state.loading = false;
        state.events = [];
        state.total = 0;
        state.error = action.payload?.message || 'Failed to fetch events.';
      });
  },
});

export const { resetParentEventState } = parentEventSlice.actions;
export default parentEventSlice.reducer;
